module.exports = __webpack_public_path__ + "mydr-logo.png?81712c6ba02eae558879d4598714fdee";


//////////////////
// WEBPACK FOOTER
// ./static/images/mydr-logo.png
// module id = 248
// module chunks = 0